import { Outlet } from 'react-router';

export const GuestLayout = () => {
  return (
    <div className="flex min-h-screen w-full items-center justify-center bg-white">
      <Outlet />
    </div>
  );
};
